export default {
  state: {
    flightInfo: {
      show: false,
      airlines: [],
      flightLoading: false,
      suggestedTime: {
        show: false,
        time: '',
        isDomestic: ''
      },
      flightTime: ''
    }
  },
  mutations: {
    showFlightInfo (state) { state.flightInfo.show = true },
    hideFlightInfo (state) { state.flightInfo.show = false },
    setAirlines (state, value) { state.flightInfo.airlines = value },
    setFlightLoading (state, value) { state.flightInfo.flightLoading = value },
    setSuggestedTimeShow (state, value) { state.flightInfo.suggestedTime.show = value },
    setSuggestedTime (state, value) { state.flightInfo.suggestedTime.time = value },
    setSuggestedTimeIsDomestic (state, value) { state.flightInfo.suggestedTime.isDomestic = value },
    setFlightTime (state, value) { state.flightInfo.flightTime = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/flight-info.js